module.exports = __webpack_public_path__ + "img/people@2x(1).27d51717.png";